module.exports = __webpack_public_path__ + "media/images/icons/outlined/rotate-right-5c7518e89cffc1ec1096ff4311a251b5.svg";